import { useMemo } from 'react';

import { useUserContext } from '@context/UserContext';
import { AB_TEST_PROGRESS_BAR_WITH_RECO } from '@utils/constants';

export const useAbTestProgressBarWithReco = () => {
  const {
    state: { abTests },
  } = useUserContext();

  return useMemo(() => {
    return {
      isWithReco: abTests.get(AB_TEST_PROGRESS_BAR_WITH_RECO) === 2,
    };
  }, [abTests]);
};
